import { render, staticRenderFns } from "./domain.vue?vue&type=template&id=6e2694a6&"
import script from "./domain.vue?vue&type=script&lang=ts&"
export * from "./domain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports